// Core
import { createApp, h } from 'vue'
import { createInertiaApp, Head, Link } from '@inertiajs/inertia-vue3'
import { InertiaProgress } from '@inertiajs/progress'
import route from 'ziggy'
import moment from 'moment'

// Base setup
const el = document.getElementById('app');
InertiaProgress.init();

createInertiaApp({
    resolve: name => require(`./Pages/${name}`),
    setup({ el, app, props, plugin }) {

        const vueApp = createApp({ render: () => h(app, props) })

        const Ziggy = {
            ...props.initialPage.props.ziggy,
            location: window.location
        }

        vueApp
            .mixin({
                methods: {
                    $route: (name, params, absolute, config = Ziggy) => route(name, params, absolute, config),
                    $date: (date, format = 'DD-MM-YYYY') => date ? moment(date).format(format) : '—',
                    $datetime: (date, format = 'DD-MM-YYYY HH:mm') => date ? moment(date).format(format) : '—',
                    $hasRole: function (roles) {
                        return this.$page.props.auth.user.role ? roles.includes(this.$page.props.auth.user.role) : null;
                    },
                    $asset: (path) => '/storage/' + path,
                    __: function (key, replace = {}) {
                        let translation = this.$page.props.__translations[key]
                            ? this.$page.props.__translations[key]
                            : key

                        Object.keys(replace).forEach(function (key) {
                            translation = translation.replace(':' + key, replace[key])
                        });

                        return translation
                    },
                    exists: (value) => value !== undefined,
                },
            })

        vueApp
            .use(plugin)
            .component('InertiaHead', Head)
            .component('InertiaLink', Link)
            .mount(el)
    },
})
